export type Language = 'nl' | 'en';

export const defaultLanguage = (): Language => 'nl';
export const supportedLanguages = (): Language[] => ['en', 'nl'];
